import React, { FunctionComponent } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import styled from 'styled-components';

const CheckboxStyled = styled(Checkbox)`
  margin-left: 12px !important;
  margin-right: 0px;
  height: 32px;

  label {
    margin-top: 2px;
  }
`;

const CheckboxFilter: FunctionComponent<CheckboxProps> = (props) => (
  <CheckboxStyled {...props} />
);

export default CheckboxFilter;
